import { z } from "zod";

export const DeleteSchedulePathParamSchema = z.object({
  scheduleId: z.string().uuid(),
});

export type DeleteSchedulePathParamType = z.infer<
  typeof DeleteSchedulePathParamSchema
>;

export const DeleteScheduleResponseBodySchema = z.string();

export type DeleteScheduleResponseBodyType = z.infer<
  typeof DeleteScheduleResponseBodySchema
>;
